import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import useProjectVariations from "src/api/hooks/useProjectVariations";
import { objectTypes } from "src/consts/objectTypes";
import { routes } from "src/routes";
import { InspectionResponse } from "src/types/InspectionUpdateRequest";

export function CalendarScreen({
  objectType,
}: {
  objectType: keyof typeof objectTypes;
}) {
  const { companyId, inspectionId } = useParams();
  const { data: inspections } = useProjectVariations();
  const location = useLocation();
  const inspectionsGroupedByDate = useMemo(() => {
    const filteredInspections: InspectionResponse[] =
      inspections?.filter((i) => i.objectType === objectType) || [];
    const groupedInspections: { [date: string]: InspectionResponse } = {};
    filteredInspections.forEach((inspection) => {
        const a = inspection.assignments
    });
    
  }, [location.pathname, inspections]);

  return <div className="w-full h-full"></div>;
}
